import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { TransactionsReportFormValues } from 'pages/Orders/hooks/useGetTransactionsReportSummary';
import qs from 'qs';
import { TransactionsReportSummary } from 'types/embedded/transactionsReportSummary';

export const getTransactionsReportSummary = async (
  filters: TransactionsReportFormValues,
): Promise<TransactionsReportSummary> => {
  const params = qs.stringify(
    {
      ...filters,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`transactions_report_summary?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
